import { render } from "./ProductDetailsPanel.vue?vue&type=template&id=6f60c49e"
import script from "./ProductDetailsPanel.vue?vue&type=script&lang=js"
export * from "./ProductDetailsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__